let AppActiveUser = JSON.parse(localStorage.getItem("userInfo"));

var isAgent = AppActiveUser && AppActiveUser.roles[0].name === 'agent' ? true : false;
var array = [];
var agentArray = [];

if (isAgent) {
        agentArray.push({
                url: "/aa/formations",
                name: "Formations",
        });
        agentArray.push({
                url: "/aa/pack-results",
                name: "Mes résultats",
        });
        agentArray.push({
                url: null,
                name: "Live Chat",
        });
        array = agentArray;
}

export default array;